import styled from "styled-components/macro";

export const TypographyBodyMediumElement = styled.h3`
  margin: 0;
  /* opacity: 0.75; */
  letter-spacing: 0.25px;
  font-weight: 400;
`;
